import { OperationItem } from 'types/operation-item';
import { Guid } from 'types/guid';

export interface OperationsState {
  items: OperationItem[];
  selectedClientTransactionId: Guid;
}

export const initialState: OperationsState = {
  items: [],
  selectedClientTransactionId: ''
};


// WEBPACK FOOTER //
// ./src/components/operation-grid/state.ts